import React from 'react';
import { Dialog } from '@tencent/spaui';
import io from 'socket.io-client'; // 2.2.0
import { NetCallLoginStateComponent } from './NetCallLoginStateComponent';
import { CallStateComponent } from './NetCallStateComponent';
import { RPCFactory } from '../../../utils/RequestUtil';
import {
  CallinState,
  CalloutState,
  alertStringMap,
} from './commonUtil';
import { handleJoin, handleLeave } from './trtc';
import { showTagEditor } from '../../pages/leadsmanage/leadsCommonFuncAndConfig';

const { hostname } = document.location;
const wsUrl = document.location.protocol == 'https:' ? `wss://${hostname}` : `ws://${hostname}`;
class WithNetCallComponentInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      netCallLoggedIn: false,
      showErrorAlert: false,
      alertString: '',
      calloutState: CalloutState.NOT_START,
      callinState: CallinState.NOT_START,
      roomId: '0',
      socket: null,
      callDetailInfo: {
        leadsId: undefined, calleePhoneNum: undefined, calleeName: undefined, calleePhoneLoc: undefined,
      },
      commingUserDetail: {
        leadsId: undefined, calleePhoneNum: undefined, calleeName: undefined, calleePhoneLoc: undefined, roomId: undefined, pstnUserId: undefined,
      },
      appId: 0,
      pstnUserId: 0,
      userSig: '',
      callHangEnabled: false,
      showLogoutTip: false,
    };
  }
  componentDidMount() {
    if (this.state.socket) {
      this.startListenServerMes();
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.socket == null && this.state.socket) {
      this.startListenServerMes();
      this.createRoom();
    }
    // 获取呼入情况下的标签信息
    if (!!prevState.commingUserDetail.roomId && prevState.commingUserDetail.roomId === this.state.callDetailInfo.roomId) {
      RPCFactory.leadsManage.getLeadsContactAction(this.state.callDetailInfo.leadsId).done((data) => {
        if (data.leadsInfo) {
          this.setState({ callDetailInfo: { ...this.state.callDetailInfo, tags: data.tags } });
        }
      });
    }
    if (
      prevState.calloutState === CalloutState.CALLING
      && (this.state.calloutState === CalloutState.USERHANGED || this.state.calloutState === CalloutState.HANGED)
    ) {
      showTagEditor({
        leadsId: this.state.callDetailInfo.leadsId,
        selected: this.state.callDetailInfo.tags,
        submitFn: this.state.callDetailInfo.updateTagsCallback,
      });
    }
  }
  initSocket = () => {
    const { socket } = this.state;
    let socket1;
    if (socket == null) {
      if (window.io) { // for test
        socket1 = window.io;
      } else {
        socket1 = io(wsUrl, {
          query: { accountId: window.pageProps.uid, userId: window.pageProps.operationUserId },
          transports: ['websocket'],
          reconnection: false,
        });
      }
      this.setState({ socket: socket1 });
    } else if (socket.disconnect) {
      socket.connect();
    }
  }
  createRoom = () => {
    this.state.socket.emit('create_room', {
      accountId: window.pageProps.uid,
      userId: window.pageProps.operationUserId,
    });
  }
  startListenServerMes = () => {
    const { socket } = this.state;
    let intervalTimer = -1;
    let timeoutTimer = -1;

    socket.on('connect', (message) => {
      console.log('socket connected!');
      if (intervalTimer !== -1) {
        clearInterval(intervalTimer);
      }
      if (timeoutTimer !== -1) {
        clearTimeout(timeoutTimer);
      }
      this.setState({ netCallLoggedIn: true });
      // 告知后端未使用过的roomId
      if (this.state.roomId !== '0') {
        socket.emit('room_created', {
          accountId: window.pageProps.uid,
          userId: window.pageProps.operationUserId,
          roomId: this.state.roomId,
        });
      }
    });
    socket.on('disconnect', (reason) => {
      if (reason === 'io server disconnect' || reason === 'transport close') {
        // the disconnection was initiated by the server, you need to reconnect manually
        intervalTimer = setInterval(() => {
          socket.connect();
        }, 2000);
        timeoutTimer = setTimeout(() => {
          if (intervalTimer !== -1) {
            clearInterval(intervalTimer);
          }
          if (timeoutTimer !== -1) {
            clearTimeout(timeoutTimer);
          }
        }, 120000);
      }
      // else the socket will automatically try to reconnect
    });
    socket.on('error', (msg) => {
      console.log(`ws return error, error message is ${msg.type}`);
      if (msg.roomId === this.state.roomId) {
        this.setState({
          showErrorAlert: true, calloutState: CalloutState.NOT_START, alertString: alertStringMap.backendError,
        });
      } else {
        this.setState({
          showErrorAlert: true, callinState: CallinState.NOT_START, alertString: alertStringMap.backendError,
        });
      }
    });
    socket.on('call_incoming', (message) => {
      this.setState({
        callinState: CallinState.COMMINGCALL,
        commingUserDetail: {
          leadsId: message.leadsId,
          calleePhoneNum: message.phone,
          calleeName: message.name,
          calleePhoneLoc: message.location,
          roomId: message.roomId,
          pstnUserId: message.pstnUserId,
        },
        callHangEnabled: true,
        appId: message.appId,
        userSig: message.userSig,
      });
    });
    socket.on('call_limited', (message) => {
      console.log(`call_limited, reason is ${message.type}`);
      this.setState({
        showErrorAlert: true, calloutState: CalloutState.NOT_START, alertString: message.reason, //alertStringMap[message.type],
      });
      if(message.type === 'INDUSTRY_LIMIT' || message.type === 'CALL_LIMIT') {
        this.logoutNetCall();
      }
    });
    socket.on('room_created', (message) => {
      console.log('room_created');
      this.setState({ roomId: message.roomId });
    });
    socket.on('enter_room', (message) => {
      console.log('enter_room');
      this.setState({
        roomId: message.roomId,
        calloutState: CalloutState.CONNECTING,
        callHangEnabled: true,
        userSig: message.userSig,
        pstnUserId: message.pstnUserId,
        appId: message.appId,
      });
      handleJoin({
        roomId: parseInt(message.roomId),
        userSig: message.userSig,
        appId: message.appId,
      });
    });
    socket.on('user_answered', (message) => {
      console.log('user_answered');
      this.setState({ calloutState: CalloutState.CALLING });
    });
    // 客服拨打用户电话，用户主动挂断的回调，reason为refused
    socket.on('call_failed', (message) => {
      console.log('call_failed');
      console.log(`message.roomId is ${message.roomId}, this.state.roomId is ${this.state.roomId}`);
      // 呼入忽略的回调
      if (message.roomId !== this.state.roomId) {
        return;
      }
      // 如果是呼入同时进行，需要保持呼入状态
      console.log('user reject the call!');
      this.userLeaveRoom();
      this.setState({ roomId: '0', calloutState: CalloutState.USERREJECTED });
      this.hideCalloutDialogWithLatency();
    });
    // 客服拨打用户电话，接通后用户挂断
    // 用户回呼客服电话，未接通挂断
    socket.on('user_hangup', (message) => {
      console.log('user_hangup');
      // 客服拨打用户挂断，如果在呼入中，返回呼入状态
      if (message.roomId === this.state.roomId) {
        this.userLeaveRoom();
        this.setState({ roomId: '0', calloutState: CalloutState.USERHANGED });
        this.hideCalloutDialogWithLatency();
      } else { // 用户回呼客服电话，未接通挂断
        this.setState({ callinState: CallinState.NOT_START }); // 需不需要提示
      }
    });
    socket.on('logout', (message) => {
      console.log(`receive logout message, reason is ${message.reason}`);
      if (message.reason == 'calling_repetition') {
        this.handleLogoutTipState(true);
      }
      this.logoutNetCall();
      this.setState({ calloutState: CalloutState.NOT_START, callinState: CallinState.NOT_START });
    });
  }
  onCallUserUsingNetCall = (callDetailInfo) => {
    const { calleeName, calleePhoneNum, calleePhoneLoc, leadsId } = callDetailInfo;
    const intervalCall = setInterval(() => {
      if (this.state.roomId !== '0') {
        clearInterval(intervalCall);
        this.state.socket.emit('start_call', {
          phone: calleePhoneNum,
          roomId: this.state.roomId,
          leadsId,
        });
      }
    }, 500);
    this.setState({ calloutState: CalloutState.CONNECTING, callDetailInfo });
  }
  userLeaveRoom = () => {
    handleLeave({ userSig: this.state.userSig });
  }
  hideCalloutDialogWithLatency = () => {
    setTimeout(() => {
      this.setState({ calloutState: CalloutState.NOT_START });
    }, 1000);
  }
  hangNetCall = () => {
    this.state.socket.emit('hangup', {
      pstnUserId: this.state.pstnUserId,
      roomId: this.state.roomId,
    });
    handleLeave({ appId: this.state.appId, userSig: this.state.userSig });
    this.setState({ calloutState: CalloutState.HANGED, roomId: '0', callHangEnabled: false });
    this.hideCalloutDialogWithLatency();
  }
  handleIgnoreCommingCall = () => {
    this.state.socket.emit('refuse', {
      roomId: this.state.commingUserDetail.roomId,
      pstnUserId: this.state.commingUserDetail.pstnUserId,
    });
    this.setState({ callinState: CallinState.NOT_START, commingUserDetail: {} });
  }
  handlePickupCommingCall = async () => {
    const newRoomId = this.state.commingUserDetail.roomId;
    const newPstnUserId = this.state.commingUserDetail.pstnUserId;

    this.setState({
      calloutState: CalloutState.CALLING,
      callinState: CallinState.NOT_START,
      callDetailInfo: this.state.commingUserDetail,
      roomId: this.state.commingUserDetail.roomId,
      pstnUserId: this.state.commingUserDetail.pstnUserId,
      callHangEnabled: true,
      commingUserDetail: {},
    });
    if (this.state.calloutState !== CalloutState.NOT_START) {
      await handleLeave({ appId: this.state.appId, userSig: this.state.userSig });
    }
    await handleJoin({
      roomId: parseInt(newRoomId),
      userSig: this.state.userSig,
      appId: this.state.appId,
    });
    this.state.socket.emit('answer', {
      roomId: newRoomId,
      pstnUserId: newPstnUserId,
    });
  }
  logoutNetCall = () => {
    if (this.state.calloutState === CalloutState.NOT_START && this.state.callinState === CallinState.NOT_START) {
      this.state.socket.emit('logout', {
        accountId: window.pageProps.uid,
        userId: window.pageProps.operationUserId,
      });
      this.setState({ netCallLoggedIn: false, roomId: '0' });
      this.state.socket.disconnect();
    }
  }
  handleLogoutTipState = (state) => {
    this.setState({ showLogoutTip: state });
  }
  onCancelAlertShow = () => {
    this.setState({ showErrorAlert: false });
  }
  render() {
    return (
      <div>
        <this.props.component
          {...this.props}
          socket={this.state.socket}
          createRoom={this.createRoom}
          initSocket={this.initSocket}
          netCallLoggedIn={this.state.netCallLoggedIn}
          calloutState={this.state.calloutState}
          callinState={this.state.callinState}
          onCallUserUsingNetCall={this.onCallUserUsingNetCall}
        />
        <div id='remote_stream' style={{ height: '0px' }}/>
        <NetCallLoginStateComponent
          show={this.state.netCallLoggedIn}
          logoutNetCall={this.logoutNetCall}
          roomId={this.state.roomId}
          showLogoutButton={
            this.state.calloutState === CalloutState.NOT_START && this.state.callinState === CallinState.NOT_START
          }
          showLogoutTip={this.state.showLogoutTip}
          handleCloseLogoutTip={() => this.handleLogoutTipState(false)}
        />
        <CallStateComponent
          show={this.state.calloutState !== CalloutState.NOT_START || this.state.callinState !== CallinState.NOT_START}
          handleHangCall={this.hangNetCall}
          handlePickupCommingCall={this.handlePickupCommingCall}
          handleIgnoreCommingCall={this.handleIgnoreCommingCall}
          user={this.state.callDetailInfo}
          commingUserDetail={this.state.commingUserDetail}
          calloutState={this.state.calloutState}
          callinState={this.state.callinState}
          callHangEnabled={this.state.callHangEnabled}
        />
        <Dialog
          time={2000}
          timeCallback={this.onCancelAlertShow}
          type='tip'
          iconType='strongwarn'
          show={this.state.showErrorAlert}
        >
          <div>{this.state.alertString}</div>
        </Dialog>
      </div>
    );
  }
}

export const withNetCall = component => props => <WithNetCallComponentInternal {...props} component={component} />;
